import { BaseComponent } from 'src/app/shared/components/base.component';
import { Component, OnInit, ViewChild, AfterViewInit, NgZone } from '@angular/core';
import { InfiniteScrollDirective } from 'src/app/shared/directives/infinite-scroll.directive';
import { envSettings } from 'src/common/constant';
import { AuthenticationService } from 'src/core/http/authentication.service';
import { BehaviorSubject, merge } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeUntil, take, finalize } from 'rxjs/operators';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { GenericDataSource } from 'src/core/http/generic.datasource';
import { MessageService } from 'src/core/http/message.service';
import { AppService } from 'src/core/services/app-service';
import * as moment from 'moment-timezone';
import { NotificationsService } from 'angular2-notifications';
import { AlertSummaryService } from 'src/core/services/alert-summary.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DialogBoxButton, DialogBoxComponent } from 'src/app/shared/components/dialog-box/dialog-box.component';
import { SortingMenuComponent } from 'src/app/shared/components/sorting-menu/sorting-menu.component';

@Component({
  selector: 'app-message-list',
  templateUrl: './message-list.component.html',
  styleUrls: ['./message-list.component.scss']
})
export class MessageListComponent extends BaseComponent implements OnInit, AfterViewInit {
  public enviOptions = envSettings;
  pageSize = 40;

  firstName = '';
  lastName = '';

  folderSelected = '';
  inboxDataSource: GenericDataSource;
  sentDataSource: GenericDataSource;
  archiveDataSource: GenericDataSource;

  columnDefinitions = [
    { columnName: 'Date', sortingName: 'Date'},
    { columnName: 'Priority', sortingName: 'Priority'},
    { columnName: 'Sender', sortingName: 'Sender'},
    { columnName: 'Subject', sortingName: 'Subject'},
  ];

  @ViewChild('inboxSortingMenu', { static: true }) inboxSortingMenu: SortingMenuComponent;
  @ViewChild('sentSortingMenu') sentSortingMenu: SortingMenuComponent;
  @ViewChild('archiveSortingMenu', { static: true }) archiveSortingMenu: SortingMenuComponent;

  constructor(
    private nz: NgZone,
    private router: Router,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private appService: AppService,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private snackbarService: NotificationsService,
    private alertSummaryService: AlertSummaryService,
    protected authenticationService: AuthenticationService,
  ) {
    super(authenticationService);
    this.enviOptions.headerSectionTitle = 'Messages';
    this.enviOptions.headerSectionIcon = { iconLibrary: 'material', iconName: 'email' };
  }

  ngOnInit(): void {
    const userInfo = this.authenticationService.userInfo;
    if (userInfo) {
      this.firstName = userInfo.AuthResult.FirstName;
      this.lastName = userInfo.AuthResult.LastName;
    }

    if (this.isAdmin) {
      this.folderSelected = 'SENT';
      setTimeout(() => { /* We used a setTimeout because 'sentSortingMenu' is driven by a container using ngIf */
        this.sentSortingMenu.activeSortName = this.columnDefinitions[0].columnName;
        this.sentSortingMenu.activeSortDirection = 'desc';
      });
    } else {
      this.folderSelected = 'INBOX';
    }

    this.inboxSortingMenu.activeSortName = this.columnDefinitions[0].columnName;
    this.inboxSortingMenu.activeSortDirection = 'desc';
    this.archiveSortingMenu.activeSortName = this.columnDefinitions[0].columnName;
    this.archiveSortingMenu.activeSortDirection = 'desc';


    this.inboxDataSource = new GenericDataSource(this.getInboxMessages);
    this.sentDataSource = new GenericDataSource(this.getSentMessages);
    this.archiveDataSource = new GenericDataSource(this.getArchivedMessages);

    merge(this.inboxDataSource.isLoading$, this.sentDataSource.isLoading$, this.archiveDataSource.isLoading$)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(loadingYN => {
      this.appService.setIsLoading(loadingYN);
    });

    this.appService.refreshMainViewYN$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(refreshYN => {
      if (refreshYN === true) {
        if (this.folderSelected === 'SENT') {
          this.sentDataSource.showNextPage(false, null, this.pageSize);
        }
        this.appService.setRefreshMainViewYN(false);
      }
    });
  }


  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   this.filterForm.get('messageType').valueChanges
    //   .pipe( takeUntil(this.unsubscribe) )
    //   .subscribe((data: any) => { console.log('Unread message filter value: ' + data); });
    // });

    setTimeout(() => {
      switch (this.folderSelected) {
        case 'INBOX':
          this.inboxDataSource.showNextPage(false, null, this.pageSize);
          break;
        case 'SENT':
          this.sentDataSource.showNextPage(false, null, this.pageSize);
          break;
        case 'ARCHIVE':
          this.archiveDataSource.showNextPage(false, null, this.pageSize);
          break;
      }
    });
  }




  getInboxMessages = (currentIndex: number, pageSize: number) => {
    return this.messageService.getInboxMessages(currentIndex, pageSize, this.inboxSortingMenu.activeSortName, this.inboxSortingMenu.activeSortDirection);
  }


  getSentMessages = (currentIndex: number, pageSize: number) => {
    return this.messageService.getSentMessages(currentIndex, pageSize, this.sentSortingMenu.activeSortName, this.sentSortingMenu.activeSortDirection);
  }


  getArchivedMessages = (currentIndex: number, pageSize: number) => {
    return this.messageService.getArchivedMessages(currentIndex, pageSize, this.archiveSortingMenu.activeSortName, this.archiveSortingMenu.activeSortDirection);
  }


  loadNextPage(event) {
    // Due to the infinite scroll directive this code is ran out of Angular's zone,
    // so in order to reactivate change detection and refresh the UI, we have to re-enter in Angular's zone.
    this.nz.run(() => {
      // thse second parameter: currentIndex is null as it is managed by the dataSource itself when dealing with Infinite scroll
      switch (this.folderSelected) {
        case 'INBOX':
          this.inboxDataSource.showNextPage(true, null, this.pageSize);
          break;
        case 'SENT':
          this.sentDataSource.showNextPage(true, null, this.pageSize);
          break;
        case 'ARCHIVE':
          this.archiveDataSource.showNextPage(true, null, this.pageSize);
          break;
      }
    });
  }


  addBtnClicked() {
    this.router.navigate(['add'], { relativeTo: this.route });
  }


  tabClicked(e: MatTabChangeEvent) {
    const tabName = e.tab.textLabel;
    switch (tabName) {
      // Inbox
      case 'INBOX': {
        // this.sentDataSource.reset();
        // this.archiveDataSource.reset();
        this.folderSelected = 'INBOX';
        this.inboxDataSource.showNextPage(false, null, this.pageSize);
        break;
      }
      // Sent
      case 'SENT': {
        // this.inboxDataSource.reset();
        // this.archiveDataSource.reset();
        this.folderSelected = 'SENT';
        this.sentDataSource.showNextPage(false, null, this.pageSize);
        break;
      }
      // Archive
      case 'ARCHIVE': {
        // this.inboxDataSource.reset();
        // this.sentDataSource.reset();
        this.folderSelected = 'ARCHIVE';
        this.archiveDataSource.showNextPage(false, null, this.pageSize);
        break;
      }
    }
  }


  onMessageOpened(message: any) {
    if (!message.ReadTmsp)  {
      this.messageService.markMessageAsRead(message.Identifier)
      .pipe(take(1))
        .subscribe(res => {
          if (res && res.State) {
            message.ReadTmsp = new moment().toISOString();
          }
      });
    }
  }


  onMessageArchive(messageObj: any, fromFolder: string) {
    this.showArchiveConfirmationDialog(messageObj, fromFolder);
  }


  showArchiveConfirmationDialog(messageObj: any, fromFolder: string) {
    // Ask confirmation before Delete
    // this.dialog.closeAll();
    const dialogRef = this.dialog.open(DialogBoxComponent, { data: { message: `Are you sure you want <br>to archive this message?`, button: DialogBoxButton.YesNo, data: { MessageObj: messageObj, FromFolder: fromFolder } } });

    dialogRef.afterClosed()
    .pipe(take(1) /*takeUntil(this.unsubscribe)*/)
    .subscribe(result => {
      if (result && result.event === 'Ok') {
        this.delete(result.data.MessageObj, result.data.FromFolder);
      }
    });
  }


  delete(messageObj: any, fromFolder: string) {
    // console.log('message: ', messageObj);
    // console.log('fromFolder: ', fromFolder);

    this.appService.setIsLoading(true);
    this.messageService.markMessageAsArchived(messageObj.Identifier, fromFolder)
    .pipe(
      take(1),
      finalize(() => { this.appService.setIsLoading(false); } )
    )
    .subscribe (
      (rawResult: any) => {
        if (rawResult && 'State' in rawResult && rawResult.State) {
          const toast = this.snackbarService.success(`Message`, 'successfully archived!');
          // Refresh the proper Grid
          switch (fromFolder) {
            case 'INBOX':
              this.inboxDataSource.showNextPage(false, null, this.pageSize);
              break;
            case 'SENT':
              this.sentDataSource.showNextPage(false, null, this.pageSize);
              break;
          }
        } else {
          this.alertSummaryService.error(rawResult.Messages);
        }
      },
      error => console.log('Error:', error),
    );
  }


  columnMenuSortingChanged(sortingObj, fromFolder) {
    // this.sort.sort({ id: sortingObj.id, start: sortingObj.start, disableClear: true });
    // console.log('sotring from: ' + fromFolder, sortingObj);
    switch (fromFolder) {
      case 'INBOX':
        this.inboxDataSource.showNextPage(false, null, this.pageSize);
        break;
      case 'SENT':
        this.sentDataSource.showNextPage(false, null, this.pageSize);
        break;
      case 'ARCHIVE':
        this.archiveDataSource.showNextPage(false, null, this.pageSize);
        break;
    }
  }


}
